var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"star-ratings",attrs:{"id":_vm.id}},[_vm._l((_vm.star_rating),function(next_item){return _c('i',{staticClass:"fa",class:[(next_item == '1' ? 'fa-star': 'fa-star-o')]})}),_vm._v(" "),_c('span',{staticClass:"fc-gray font-aleo"},[_vm._v(_vm._s(_vm.rating)+"/5")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72b8f008","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/common/StarRating/star-rating.html
// module id = null
// module chunks = 